/**
 * Demo state for the `web:drive-time-pins` walkthrough (registry §17.10,
 * guide §5 "demo state instead of real state").
 *
 * A tour must never change real data, and it must show the same thing every
 * time. So the visit it opens, the customer on the Available Sooner list and
 * the numbers in the compare dialog are these fixed values, not a real
 * customer, a real visit or a real Google lookup. Public addresses, so the
 * route map still draws a real route.
 */
import { makePlace } from "../../../../utils/DriveTimePin/DriveTimePinContext";

export const DEMO_CUSTOMER = {
  _id: null,
  firstName: "Example",
  lastName: "Customer",
  streetAddress: "300 Alamo Plaza",
  city: "San Antonio",
  state: "TX",
  zipCode: "78205",
  phoneNumberIds: [],
  clientPhotoIds: [],
};

/* The start pin used only when the walkthrough could not reach a customer's
   page (no recently viewed client) — a second public address, so the demo
   route has two distinct points. */
export const DEMO_START_PLACE = makePlace("Example start", {
  streetAddress: "100 Military Plaza",
  city: "San Antonio",
  state: "TX",
  zipCode: "78205",
});

export const DEMO_LEGS = {
  fromStart: { ok: true, distanceMeters: 14322, durationSec: 23 * 60 },
  toEnd: { ok: true, distanceMeters: 9978, durationSec: 17 * 60 },
};

export const DEMO_ROW_DRIVE_TEXT = "12 min from start · 18 min to end";

/* The next weekday at 10:00 local, built with the date constructor (never
   millisecond arithmetic across a DST change). */
const nextWeekdayTenAm = () => {
  const d = new Date();
  d.setHours(10, 0, 0, 0);
  do {
    d.setDate(d.getDate() + 1);
  } while (d.getDay() === 0 || d.getDay() === 6);
  return d.getTime();
};

/** A `CalendarItemWithDetails`-shaped visit the event popup can render. */
export const demoVisitItem = () => {
  const startMs = nextWeekdayTenAm();
  const endMs = new Date(startMs);
  endMs.setHours(12, 0, 0, 0);
  return {
    calendarItem: {
      id: "tour-demo-visit",
      // An invoice id keeps the "Tent." prefix off the title; the popup only
      // offers the invoice button when `item.invoice` itself is present.
      invoiceId: "tour-demo-visit",
      eventType: "job",
      startMs: String(startMs),
      endMs: String(endMs.getTime()),
      availableSooner: false,
      assignedUserIds: [],
      priorityNotes: [],
      workDays: [],
      note: null,
    },
    customer: DEMO_CUSTOMER,
    assignedUsers: [],
    invoice: null,
    quote: null,
    calNotes: [],
  };
};
